export const STORAGE_DONE = "onboarding_v2";
export const STORAGE_WELCOMED = "onboarding_welcomed_v2";

export const isDismissed = () => localStorage.getItem(STORAGE_DONE) === "done";

export const dismiss = () => {
  localStorage.setItem(STORAGE_DONE, "done");
  window.dispatchEvent(new Event("onboarding-change"));
};

export const isWelcomed = () => !!localStorage.getItem(STORAGE_WELCOMED);

export const setWelcomed = () => {
  localStorage.setItem(STORAGE_WELCOMED, "1");
  window.dispatchEvent(new Event("onboarding-change"));
};
